import apiService from "@/lib/api";

// The reply inbox: the candidate replies a recruiter still has to handle.
// The message log that used to live here moved to communicationsService —
// it backs the Communication Center's Table view, and a component test mocks
// the page's own domain service. `list` below is a different endpoint, and
// SequenceReducer still reads it.
const BASE = "/api/v2/outreach/inbox";

export const InboxService = {
  list: async ({ page = 1, pageSize = 50, sentiment, sequenceId, handled } = {}) => {
    const params = { page, page_size: pageSize };
    if (sentiment) params.sentiment = sentiment;
    if (sequenceId) params.sequence_id = sequenceId;
    if (handled !== undefined && handled !== null) params.handled = handled;
    const r = await apiService.getSecure(BASE, { params });
    return r.data;
  },
  handle: async (replyId, notes) => {
    const r = await apiService.postSecure(`${BASE}/${replyId}/handle`, { notes });
    return r.data;
  },
  // Simulate an inbound reply (for testing / when no webhook is set up)
  simulateReply: async ({ messageId, fromEmail, text, sentiment }) => {
    const r = await apiService.postSecure(`${BASE}/simulate`, {
      message_id: messageId,
      from_email: fromEmail,
      raw_text: text,
      sentiment,
    });
    return r.data;
  },
};

export default InboxService;
